export default "/images/1d46d55be3edcc7217671c65ad2ba363.png";